module.exports = __webpack_public_path__ + "static/img/brees-2008-top-image.40a22da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-top-image.jpg
// module id = EGMR
// module chunks = 1